export default __webpack_public_path__ + "static/media/kafka.31b4a8cc6be07b6c2a85a57f036d0434.svg";